import SharedNavbar from '../../../components/feature/SharedNavbar';
import SharedFooter from '../../../components/feature/SharedFooter';
import FloatingCallButton from '../../../components/feature/FloatingCallButton';
import ServiceHero from '../components/ServiceHero';
import ServiceContent from '../components/ServiceContent';
import ServiceCTA from '../components/ServiceCTA';

export default function SurgeProtectionPage() {
  const serviceData = {
    title: 'Surge Protection',
    subtitle: 'Protect Your Valuable Electronics',
    description: 'Safeguard your expensive appliances and electronics from damaging power surges. Our surge protection solutions provide comprehensive defense against voltage spikes caused by lightning, power grid fluctuations, and electrical faults.',
    heroImage: 'https://public.readdy.ai/ai/img_res/d34b70c65f5fe7203f1c9f19f8037466.jpg',
    features: [
      {
        icon: 'ri-shield-flash-line',
        title: 'Whole-House Protection',
        description: 'Comprehensive surge protection for entire property'
      },
      {
        icon: 'ri-computer-line',
        title: 'Device Safety',
        description: 'Protect computers, TVs, and appliances'
      },
      {
        icon: 'ri-thunderstorms-line',
        title: 'Lightning Defense',
        description: 'Protection against lightning strikes'
      },
      {
        icon: 'ri-money-dollar-circle-line',
        title: 'Save Money',
        description: 'Prevent costly equipment replacement'
      }
    ],
    benefits: [
      'Whole-house surge protection',
      'Individual circuit protection',
      'Lightning surge defense',
      'Power grid spike protection',
      'Appliance damage prevention',
      'Insurance claim reduction',
      'Professional installation',
      'Quality surge protection devices'
    ],
    processSteps: [
      {
        number: '01',
        title: 'Risk Assessment',
        description: 'Evaluate your property\'s surge protection needs'
      },
      {
        number: '02',
        title: 'Solution Design',
        description: 'Recommend appropriate protection levels'
      },
      {
        number: '03',
        title: 'Installation',
        description: 'Install surge protection devices at switchboard'
      },
      {
        number: '04',
        title: 'Verification',
        description: 'Test and verify protection is functioning'
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SharedNavbar />
      <ServiceHero 
        title={serviceData.title}
        subtitle={serviceData.subtitle}
        description={serviceData.description}
        heroImage={serviceData.heroImage}
      />
      <ServiceContent 
        features={serviceData.features}
        benefits={serviceData.benefits}
        processSteps={serviceData.processSteps}
      />
      <ServiceCTA />
      <div className="pb-20 lg:pb-0">
        <SharedFooter />
      </div>
      <FloatingCallButton />
    </div>
  );
}